module.exports = __webpack_public_path__ + "img/yuan.81bd936b.png";